import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';

export interface FreshdeskRedirectResponse {
  redirectUrl: string;
}

export const freshdeskService = {
  getRedirectUrl: async (params?: {
    state?: string;
    nonce?: string;
    redirectUri?: string;
  }): Promise<string> => {
    const queryParams = new URLSearchParams();
    if (params?.state) queryParams.set('state', params.state);
    if (params?.nonce) queryParams.set('nonce', params.nonce);
    if (params?.redirectUri) queryParams.set('redirectUri', params.redirectUri);

    const endpoint = `/freshdesk/redirect${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await httpClient.get<FreshdeskRedirectResponse>(endpoint);

    if (!response.data) {
      throw new Error('No se recibió URL de redirección');
    }

    return response.data.redirectUrl;
  },

  redirectToFreshdesk: async (): Promise<void> => {
    const redirectUrl = await freshdeskService.getRedirectUrl();
    window.location.href = redirectUrl;
  },

  openInNewTab: async (): Promise<void> => {
    const popup = window.open('about:blank', '_blank');
    if (!popup) {
      throw new Error('El navegador bloqueó la apertura de la pestaña. Permite popups para este sitio.');
    }
    const redirectUrl = await freshdeskService.getRedirectUrl();
    popup.location.href = redirectUrl;
  },
};
